import { Component, Input } from '@angular/core';
import { CompanyBanner } from '@shared/models/company.model';

@Component({
  selector: 'pl-company-banner',
  templateUrl: './companyBanner.component.html',
})
export class CompanyBannerComponent {
  @Input() public options: CompanyBanner | null = null;
}
